/**
 * @file        src/pages/hotel/CorporateConvenienceFee.jsx
 * @description Corporate Hotel → Convenience Fee. Same list/form as the B2C
 *              Hotel Convenience Fee (ConvenienceFee.jsx), fixed to
 *              audience=b2b, instead of forking the page.
 * @author      Kinetika Labs
 * @created     2026-08-10
 * @changelog
 *   - 2026-08-10 Claude — Initial (Corporate Hotel menu parity with B2C).
 */
import ConvenienceFee from './ConvenienceFee';

export default function CorporateConvenienceFee() {
  return (
    <ConvenienceFee
      title="Corporate Convenience Fee"
      subtitle="Corporate Hotel · B2B convenience fee rules"
      audience="b2b"
    />
  );
}
